import { render } from "./milestone-form-footer-plan.vue?vue&type=template&id=c5d4a1f2&scoped=true&ts=true"
import script from "./milestone-form-footer-plan.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer-plan.vue?vue&type=script&lang=ts"

import "./milestone-form-footer-plan.vue?vue&type=style&index=0&id=c5d4a1f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d4a1f2"]])

export default __exports__